import { CSSProperties, useState, useEffect } from 'react'
import { SystemMessage } from 'Hooks/useMaestroChat'
import { styx } from 'modules/Utils'
import Colors from 'modules/Colors'
import Icon from 'elements/Icon'

const SystemMessages = ({ messages, initiallyOpen = false }: { messages: SystemMessage[], initiallyOpen?: boolean }) => {
    const [isOpen, setIsOpen] = useState(initiallyOpen)

    useEffect(() => {
        setIsOpen(initiallyOpen)
    }, [initiallyOpen])

    if (!messages || messages.length === 0) {
        return null
    }

    const sty: Record<string, CSSProperties> = {
        thinkingProcessContainer: {
            marginBottom: 8,
            backgroundColor: Colors.greyLight,
            borderRadius: 8,
            padding: '8px 12px',
            border: `1px solid ${Colors.grey}`,
            maxWidth: 250,
        },
        thinkingProcessHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            fontWeight: 500,
            color: Colors.textColor,
        },
        headerText: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
        },
        systemMessagesContent: {
            paddingTop: 8,
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
        },
        systemMessageInline: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            backgroundColor: Colors.greyLight,
            borderRadius: 8,
            padding: '4px 8px',
            fontSize: 12,
            color: Colors.greyDark,
            border: `1px solid ${Colors.grey}`,
            alignSelf: 'flex-start',
            maxWidth: '100%',
            fontStyle: 'italic',
        },
        systemMessageText: {
            fontWeight: 500,
        },
        systemMessage_router_start: {
            backgroundColor: '#f0f9ff',
            borderColor: '#0ea5e9',
            color: '#0369a1',
        },
        systemMessage_specialist_activated: {
            backgroundColor: '#f0fdf4',
            borderColor: '#22c55e',
            color: '#15803d',
        },
        systemMessage_tool_call_start: {
            backgroundColor: '#fefce8',
            borderColor: '#eab308',
            color: '#a16207',
        },
        systemMessage_tool_call_end: {
            backgroundColor: '#f0fdf4',
            borderColor: '#22c55e',
            color: '#15803d',
            animation: 'none',
        },
    }

    return (
        <div className="thinkingProcessContainer" style={sty.thinkingProcessContainer}>
            <div
                className="thinkingProcessHeader"
                style={sty.thinkingProcessHeader}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div style={sty.headerText}>
                    <Icon
                        icon="gem"
                        size={16}
                        className="thinkingProcessIcon"
                    />
                    <span>{isOpen ? 'Hide thinking' : 'Show thinking'}</span>
                </div>
                <Icon
                    icon={isOpen ? 'chevronUp' : 'chevronDown'}
                    size={16}
                    className="thinkingProcessToggleIcon"
                />
            </div>
            {isOpen && (
                <div className="systemMessagesContent" style={sty.systemMessagesContent}>
                    {messages.filter(msg => msg.isVisible).map((msg) => (
                        <div
                            key={msg.id}
                            className={`systemMessageInline ${msg.type}`}
                            style={styx(sty.systemMessageInline, sty[`systemMessage_${msg.type}`] || {})}
                        >
                            <span className="systemMessageText" style={sty.systemMessageText}>
                                {msg.message}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default SystemMessages